const BehaviorTypes = {
    NOTIFICATIONS: 'NOTIFICATIONS',
    INVITATION_CLICKABLES: 'INVITATION_CLICKABLES',
    FAST_DOM_UI_RENDERING: 'FAST_DOM_UI_RENDERING'
};
export default BehaviorTypes;
